export enum UserInfoRole {
  OWNER = 'OWNER',
  VIEWER = 'VIEWER'
}

export type UserInfo = {
  role: UserInfoRole
  name?: string
  avatar?: string
  email?: string
}

export type GetUserInfoParams = {
  userId: string
  slug: string
}
